import * as React from 'react';
import { ISearchResult } from '../../common/api/searchApi.types';
import SearchResult from './search-result';
import { IResultListProps } from './search-results.types';
import { v4 as uuidv4 } from "uuid";

const SearchResults: React.FC<IResultListProps> = ({ results, onResultClick }) => {
    const renderResults = ((result: ISearchResult, index: number) =>
        <SearchResult result={result} key={uuidv4()} onClick={onResultClick} />
    );

    return (
        <>
            {results.map((result, index) => renderResults(result, index))}
        </>
    )
}

export default SearchResults;